import { usePathname, useSearchParams } from "next/navigation"
import { useEffect, useMemo, useRef, useState } from "react"

/**
 * 获取当前完整 URL，初始使用 pathname + searchParams，挂载后更新为 window.location.href。
 * 仅在 URL 真实变更时更新，避免多余重渲染。
 */
export const useCurrentUrl = () => {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const initialUrl = useMemo(() => {
    const queryString = searchParams.toString()
    return queryString ? `${pathname}?${queryString}` : pathname
  }, [pathname, searchParams])

  const urlRef = useRef(initialUrl)
  const [currentUrl, setCurrentUrl] = useState(initialUrl)

  useEffect(() => {
    if (typeof window === "undefined") return
    const fullUrl = window.location.href
    if (fullUrl && fullUrl !== urlRef.current) {
      urlRef.current = fullUrl
      setCurrentUrl(fullUrl)
    }
  }, [pathname, searchParams])

  return currentUrl
}
